export default "__VITE_ASSET__CzaMYMO___"